(() => {
  const header = document.querySelector("[data-site-header]");
  const menu = document.querySelector("[data-menu-panel]");
  const openers = document.querySelectorAll("[data-open-menu]");
  const closers = document.querySelectorAll("[data-close-menu]");

  const setScrolled = () => {
    if (!header) return;
    header.classList.toggle("is-scrolled", window.scrollY > 60);
  };

  const openMenu = () => {
    if (!menu) return;
    menu.hidden = false;
    document.body.classList.add("menu-open");
  };

  const closeMenu = () => {
    if (!menu) return;
    menu.hidden = true;
    document.body.classList.remove("menu-open");
  };

  window.addEventListener("scroll", setScrolled, { passive: true });
  setScrolled();
  openers.forEach((button) => button.addEventListener("click", openMenu));
  closers.forEach((button) => button.addEventListener("click", closeMenu));
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeMenu();
  });

  document.querySelectorAll("[data-product-form]").forEach((form) => {
    const idInput = form.querySelector("[name='id']");
    const price = form.querySelector("[data-variant-price]");
    const available = form.querySelector("[data-variant-available]");
    const submit = form.querySelector("[type='submit']");
    const variants = JSON.parse(form.querySelector("[data-variants-json]")?.textContent || "[]");

    form.querySelectorAll("[data-variant-option]").forEach((button) => {
      button.addEventListener("click", () => {
        const variant = variants.find((item) => String(item.id) === button.dataset.variantOption);
        if (!variant || !idInput) return;
        idInput.value = variant.id;
        form.querySelectorAll("[data-variant-option]").forEach((item) => item.classList.remove("is-active"));
        button.classList.add("is-active");
        if (price) price.textContent = variant.price;
        if (available) available.textContent = variant.available ? "In stock" : "Sold out";
        if (submit) {
          submit.disabled = !variant.available;
          submit.textContent = variant.available ? "Add to Cart" : "Sold Out";
        }
      });
    });
  });
})();
